import { render, staticRenderFns } from "./commonVehicles.vue?vue&type=template&id=2c3485a8&scoped=true"
import script from "./commonVehicles.vue?vue&type=script&lang=js"
export * from "./commonVehicles.vue?vue&type=script&lang=js"
import style0 from "./commonVehicles.vue?vue&type=style&index=0&id=2c3485a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3485a8",
  null
  
)

export default component.exports